module.exports = __webpack_public_path__ + "img/transfer-add.e98f7b38.svg";